import { loadable } from 'utils';

export const Delivery = loadable(() => import('./Delivery'), {});
export const Payments = loadable(() => import('./Payments'), {});
export const Products = loadable(() => import('./Products'), {});
